import { useEffect, useRef, useState } from "react";

import { useTranslation } from "react-i18next";
import Resizer from "react-image-file-resizer";
import { useDispatch } from "react-redux";

import { useToast } from "hooks/toast";

import { updateGlobalConfigurationsAction } from "store/modules/globalConfiguration/actions";
import { hideLoading, showLoading } from "store/modules/loading/actions";
import { useAppSelector } from "store/rootReducer";

import { LoadSpinner } from "features/LoadSpinner";

import { AdminArea } from "components/Body/AdminArea";
import { Drawer } from "components/Drawer";
import { DropdownGlobal, IDropDown } from "components/DropdownGlobal";
import ModalDefault from "components/ModalDefault";

import { SystemConfigurationService } from "services/systemConfiguration/index";

import { FORMS_ADMIN } from "utils/entities/permission";

import {
  getListDaysAux,
  getListFirstShortcut,
  listPagination,
  getListProviderAux,
  getListSecondShortcut,
  getListSecondsToNextBack,
  getListYesOrNoAux,
  getEditConfig,
  getListWaterMarkProvider,
  getListRecordProvider,
  getListFilterPeriodDays,
} from "./constants";
import AccessVideoExpiration from "./customConfigsComponents/AccessVideoExpiration";
import CustomerProcedureDeadline from "./customConfigsComponents/CustomerProcedureDeadline";
import EmailTemplate from "./customConfigsComponents/EmailTemplate";
import ExpireInHearingFileUrl from "./customConfigsComponents/ExpireInHearingFileUrl";
import ExternalLinkTextEmail from "./customConfigsComponents/ExternalLinkTextEmail";
import LoginConfigurationCustom from "./customConfigsComponents/LoginConfigurationCustom";
import LogoCustom from "./customConfigsComponents/LogoCustom";
import MConfConfiguration from "./customConfigsComponents/MConfConfiguration";
import MConfWebhookConfiguration from "./customConfigsComponents/MConfWebhookConfiguration";
import MFAConfiguration from "./customConfigsComponents/MFAConfiguration";
import ProcedureMask from "./customConfigsComponents/ProcedureMask";
import ServiceIntegrationAuthentication from "./customConfigsComponents/ServiceIntegrationAuthentication";
import ServiceIntegrationImportation from "./customConfigsComponents/ServiceIntegrationImportation";
import ServiceIntegrationNotification from "./customConfigsComponents/ServiceIntegrationNotification";
import { ShortCuts } from "./customConfigsComponents/shortcutsCustom/index";
import StorageProviderCustom from "./customConfigsComponents/StorageProviderCustom";
import TranscriptionProvider from "./customConfigsComponents/TranscriptionProvider";
import WatermarkCustom from "./customConfigsComponents/WatermarkCustom";
import WatermarkProvider from "./customConfigsComponents/WatermarkProvider";
import { ISystemWatermark, typesInput } from "./interface";
import { Container } from "./styles";

interface IShortcut {
  name: string;
  value: string;
}

export function SystemConfiguration() {
  const { t } = useTranslation();

  const listYesOrNoAux = getListYesOrNoAux(t);
  const listDaysAux = getListDaysAux(t);
  const listFilterPeriodDays = getListFilterPeriodDays(t);
  const listProviderAux = getListProviderAux(t);
  const listFirstShortcut = getListFirstShortcut(t);
  const listSecondShortcut = getListSecondShortcut(t);
  const listSecondsToNextBack = getListSecondsToNextBack(t);
  const listWaterMarkProvider = getListWaterMarkProvider(t);
  const editConfig = getEditConfig(t);
  const listRecordProvider = getListRecordProvider(t);

  const [fieldError, setFieldError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const { containerName } = useAppSelector((state) => state.profile);
  const { user } = useAppSelector((state) => state.user);

  const dispatch = useDispatch();
  const { addToast } = useToast();

  const [selectedYesOrNoName, setSelectedYesOrNoName] = useState<string>("");
  const [selectedRecordProvider, setSelectedRecordProvider] =
    useState<string>("");
  const [
    selectedAccessVideoExpirationName,
    setSelectedAccessVideoExpirationName,
  ] = useState<string>("1");
  const [
    selectedExpireInHearingFileUrlName,
    setSelectedExpireInHearingFileUrlName,
  ] = useState<string>("1");

  const [selectedDaysToGetProcedureName, setSelectedDaysToGetProcedureName] =
    useState<string>("");

  const [selectedFilterPeriodName, setSelectedFilterPeriodName] =
    useState<string>("");

  //SHORTCUTS
  //para o boby
  const [shortCutsErrorplayStop, setShortCutsErrorPlayStop] = useState(false);
  const [shortCutsErrorActionBackTime, setShortCutsErrorActionBackTime] =
    useState(false);
  const [shortCutsErrorActionNextTime, setShortCutsErrorActionNextTime] =
    useState(false);
  const [shortCutsErrorSlowSpeed, setShortCutsErrorSlowSpeed] = useState(false);
  const [shortCutsErrorFastSpeed, setShortCutsErrorFastSpeed] = useState(false);

  //-------------------------------------------------
  //para controle

  const [selectedListFirstShortcut, setSelectedListFirstShortcut] = useState<
    Array<IDropDown>
  >([]);

  const [selectedListSecondShortcut, setSelectedListSecondShortcut] = useState<
    Array<IDropDown>
  >([]);

  const [selectedListSecondsToNextBack, setSelectedListSecondsToNextBack] =
    useState<Array<IDropDown>>([]);

  const [valueTimeBackNextName, setTimeBackNextName] = useState<string>(
    listSecondsToNextBack[0]?.name,
  );
  const [valueTimeBackNextId, setTimeBackNextId] = useState<number>(5);

  const [valuePlayStopFirstName, setPlayStopFirstName] = useState<string>(
    listFirstShortcut[0]?.name,
  );
  const [valuePlayStopFirstId, setPlayStopFirstId] = useState<number>(0);

  const [valuePlayStopSecondName, setPlayStopSecondName] = useState<string>(
    listSecondShortcut[0]?.name,
  );
  const [valuePlayStopSecondId, setPlayStopSecondId] = useState<number>(0);

  const [valueActionBackTimeFirstName, setActionBackTimeFirstName] =
    useState<string>(listFirstShortcut[0]?.name);
  const [valueActionBackTimeFirstId, setActionBackTimeFirstId] =
    useState<number>(0);

  const [valueActionBackTimeSecondName, setActionBackTimeSecondName] =
    useState<string>(listSecondShortcut[0]?.name);
  const [valueActionBackTimeSecondId, setActionBackTimeSecondId] =
    useState<number>(0);

  const [valueActionNextTimeFirstName, setActionNextTimeFirstName] = useState(
    listFirstShortcut[0]?.name,
  );
  const [valueActionNextTimeFirstId, setActionNextTimeFirstId] =
    useState<number>(0);

  const [valueActionNextTimeSecondName, setActionNextTimeSecondName] =
    useState<string>(listSecondShortcut[0]?.name);
  const [valueActionNextTimeSecondId, setActionNextTimeSecondId] =
    useState<number>(0);

  const [valueSlowSpeedFirstName, setSlowSpeedFirstName] = useState<string>(
    listFirstShortcut[0]?.name,
  );
  const [valueSlowSpeedFirstId, setSlowSpeedFirstId] = useState<number>(0);

  const [valueSlowSpeedSecondName, setSlowSpeedSecondName] = useState<string>(
    listSecondShortcut[0]?.name,
  );
  const [valueSlowSpeedSecondId, setSlowSpeedSecondId] = useState<number>(0);

  const [valueFastSpeedFirstName, setFastSpeedFirstName] = useState<string>(
    listFirstShortcut[0]?.name,
  );
  const [valueFastSpeedFirstId, setFastSpeedFirstId] = useState<number>(0);

  const [valueFastSpeedSecondName, setFastSpeedSecondName] = useState<string>(
    listSecondShortcut[0]?.name,
  );
  const [valueFastSpeedSecondId, setFastSpeedSecondId] = useState<number>(0);

  const [withIndexing, setWithIndexing] = useState(false);

  const systemWaterMarkId = useRef<number>(0);

  const systemWaterMark = useRef<ISystemWatermark>();

  //=====================================================================================

  const [selectedListPagination, setSelectedListPagination] = useState<
    Array<IDropDown>
  >([]);

  const [valuePaginationName, setPaginationName] = useState<string>(
    listPagination[0]?.name,
  );

  const [mConf, setMConf] = useState<any>();
  const [mConfValue, setMConfValue] = useState(mConf || "");

  const [mConfWebhook, setMConfWebhook] = useState<any>();
  const [mConfWebhookValue, setMConfWebhookValue] = useState(
    mConfWebhook || "",
  );

  const [showModal, setShowModal] = useState(false);
  const [drawerButtonLabel, setDrawerButtonLabel] = useState<string>(
    t("common.apply"),
  );
  const [showRenewModal, setShowRenewModal] = useState(false);

  async function onLoadList() {
    const response = await SystemConfigurationService.getAllByCustomer(
      user?.customerId,
    );

    if (response) {
      if (response.status) {
        const listFilter = response.data?.filter(
          (x: any) => x.customerId !== 0,
        );

        for (let i = 0; i < listFilter.length; i++) {
          if (listFilter[i]?.name === "DaysToGetProcedure") {
            if (listFilter[i].value === "30") {
              setSelectedDaysToGetProcedureName(listDaysAux[0]?.name);
            }
            if (listFilter[i].value === "60") {
              setSelectedDaysToGetProcedureName(listDaysAux[1]?.name);
            }
          }
          if (listFilter[i]?.name === "FilterPeriod") {
            const filterPeriodValue: number = parseInt(
              listFilter[i].value as string,
            );
            const filterPeriodName = listFilterPeriodDays.find(
              (x) => x?.id === filterPeriodValue,
            )?.name;
            setSelectedFilterPeriodName(
              filterPeriodName === undefined
                ? t("constants.today")
                : filterPeriodName,
            );
          }
          if (listFilter[i].name === "FacialRecognition") {
            if (listFilter[i].value === "true" || listFilter[i].value === "1") {
              setSelectedYesOrNoName(listYesOrNoAux[1]?.name);
            }
            if (
              listFilter[i].value === "false" ||
              listFilter[i].value === "0"
            ) {
              setSelectedYesOrNoName(listYesOrNoAux[0]?.name);
            }
          }
          if (listFilter[i]?.name === "PaginationList") {
            const paginationListAuxId: number = parseInt(
              listFilter[i].value as string,
            );

            const paginationListAuxName = listPagination.find(
              (x) => x?.id === paginationListAuxId,
            )?.name;

            setPaginationName(
              paginationListAuxName === undefined ? "5" : paginationListAuxName,
            );
          }
          //ShortCuts
          if (listFilter[i]?.name === "Shortcuts") {
            const listShortcuts: Array<IShortcut> = JSON.parse(
              listFilter[i].value,
            );
            if (listShortcuts.length > 0) {
              separateFirstAndSecond(listShortcuts);
            }
          }
          // AccessVideoExpiration
          if (listFilter[i]?.name === "AccessVideoExpiration") {
            setSelectedAccessVideoExpirationName(listFilter[i].value);
          }
          // ExpireInHearingFileUrl
          if (listFilter[i]?.name === "ExpireInHearingFileUrl") {
            setSelectedExpireInHearingFileUrlName(listFilter[i].value);
          }
        }
      } else {
        addToast({
          type: "warning",
          title: response.message,
        });
      }
    }

    dispatch(hideLoading());
    return [];
  }

  function validateFormFields(values: IShortcut[]) {
    setShortCutsErrorPlayStop(false);
    setShortCutsErrorActionBackTime(false);
    setShortCutsErrorActionNextTime(false);
    setShortCutsErrorSlowSpeed(false);
    setShortCutsErrorFastSpeed(false);

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    values &&
      values.forEach((value: IShortcut) => {
        switch (value?.name) {
          case "playStop":
            setShortCutsErrorPlayStop(true);
            break;
          case "actionBackTime":
            setShortCutsErrorActionBackTime(true);
            break;
          case "actionNextTime":
            setShortCutsErrorActionNextTime(true);
            break;
          case "slowSpeed":
            setShortCutsErrorSlowSpeed(true);
            break;
          case "fastSpeed":
            setShortCutsErrorFastSpeed(true);
            break;
        }
      });
  }

  const findDuplicates = (array: IShortcut[]) => {
    const valueCount: { [key: string]: number } = {};
    const duplicates: IShortcut[] = [];

    array.forEach((item: IShortcut) => {
      if (valueCount[item.value]) {
        valueCount[item.value]++;
      } else {
        valueCount[item.value] = 1;
      }
    });

    array.forEach((item: IShortcut) => {
      if (valueCount[item.value] > 1) {
        duplicates.push(item);
      }
    });
    validateFormFields(duplicates);
    return duplicates;
  };

  function serializeShortcuts() {
    const joinTimeBackNext = valueTimeBackNextId.toString();
    const joinPlayStop = joinShortcutsFirstAndSecond(
      listFirstShortcut,
      valuePlayStopFirstId,
      listSecondShortcut,
      valuePlayStopSecondId,
    );
    const joinActionBackTime = joinShortcutsFirstAndSecond(
      listFirstShortcut,
      valueActionBackTimeFirstId,
      listSecondShortcut,
      valueActionBackTimeSecondId,
    );
    const joinActionNextTime = joinShortcutsFirstAndSecond(
      listFirstShortcut,
      valueActionNextTimeFirstId,
      listSecondShortcut,
      valueActionNextTimeSecondId,
    );
    const joinSlowSpeed = joinShortcutsFirstAndSecond(
      listFirstShortcut,
      valueSlowSpeedFirstId,
      listSecondShortcut,
      valueSlowSpeedSecondId,
    );
    const joinFastSpeed = joinShortcutsFirstAndSecond(
      listFirstShortcut,
      valueFastSpeedFirstId,
      listSecondShortcut,
      valueFastSpeedSecondId,
    );

    const playStopAux: IShortcut = { name: "playStop", value: joinPlayStop };

    const actionBackTimeAux: IShortcut = {
      name: "actionBackTime",
      value: joinActionBackTime,
    };

    const actionNextTimeAux: IShortcut = {
      name: "actionNextTime",
      value: joinActionNextTime,
    };
    const timeBackNextAux: IShortcut = {
      name: "timeBackNext",
      value: joinTimeBackNext,
    };
    const slowSpeedAux: IShortcut = { name: "slowSpeed", value: joinSlowSpeed };
    const fastSpeedAux: IShortcut = { name: "fastSpeed", value: joinFastSpeed };

    const auxList: Array<IShortcut> = [];
    auxList.push(playStopAux);
    auxList.push(actionBackTimeAux);
    auxList.push(actionNextTimeAux);
    auxList.push(timeBackNextAux);
    auxList.push(slowSpeedAux);
    auxList.push(fastSpeedAux);

    findDuplicates(auxList);

    const valueSet = new Set();
    for (const item of auxList) {
      if (valueSet.has(item.value)) {
        return addToast({
          type: "error",
          title: t("common.warning"),
          description: t("systemConfiguration.toasts.duplicateConfig"),
        });
      }
      valueSet.add(item.value);
    }
    setLocalstorageToShortcuts(auxList);

    return JSON.stringify(auxList);
  }

  function setLocalstorageToShortcuts(listShortcuts: Array<IShortcut>) {
    for (let i = 0; i < listShortcuts.length; i++) {
      if (listShortcuts[i]?.name === "playStop") {
        localStorage.setItem("GlobalPlayStop", listShortcuts[i].value);
      }
      if (listShortcuts[i]?.name === "actionNextTime") {
        localStorage.setItem("GlobalActionNextTime", listShortcuts[i].value);
      }
      if (listShortcuts[i]?.name === "actionBackTime") {
        localStorage.setItem("GlobalActionBackTime", listShortcuts[i].value);
      }
      if (listShortcuts[i]?.name === "slowSpeed") {
        localStorage.setItem("GlobalSlowSpeed", listShortcuts[i].value);
      }
      if (listShortcuts[i]?.name === "fastSpeed") {
        localStorage.setItem("GlobalFastSpeed", listShortcuts[i].value);
      }
      if (listShortcuts[i]?.name === "timeBackNext") {
        localStorage.setItem("GlobalTimeBackNext", listShortcuts[i].value);
      }
    }
  }

  function joinShortcutsFirstAndSecond(
    listFirstShortcut: Array<IDropDown>,
    valueFirstId: number,
    listSecondShortcut: Array<IDropDown>,
    valueSecondId: number,
  ) {
    let stringToValue = "";
    if (valueFirstId !== 0) {
      stringToValue = listFirstShortcut[valueFirstId]?.name + "+";
    }

    if (valueSecondId === 13) {
      stringToValue += "ArrowLeft";
    } else if (valueSecondId === 14) {
      stringToValue += "ArrowUp";
    } else if (valueSecondId === 15) {
      stringToValue += "ArrowRight";
    } else if (valueSecondId === 16) {
      stringToValue += "ArrowDown";
    } else {
      stringToValue += listSecondShortcut[valueSecondId]?.name;
    }

    return stringToValue;
  }

  function separateFirstAndSecond(listShortcuts: Array<IShortcut>) {
    const playStopAux = listShortcuts.find(
      (x) => x?.name === "playStop",
    )?.value;
    const playStopAuxSplit = playStopAux?.split("+");
    mapShortcutState(
      playStopAuxSplit,
      setPlayStopFirstId,
      setPlayStopFirstName,
      setPlayStopSecondId,
      setPlayStopSecondName,
    );

    const actionBackTimeAux = listShortcuts.find(
      (x) => x?.name === "actionBackTime",
    )?.value;
    const actionBackTimeSplit = actionBackTimeAux?.split("+");

    mapShortcutState(
      actionBackTimeSplit,
      setActionBackTimeFirstId,
      setActionBackTimeFirstName,
      setActionBackTimeSecondId,
      setActionBackTimeSecondName,
    );

    const actionNextTimeAux = listShortcuts.find(
      (x) => x?.name === "actionNextTime",
    )?.value;
    const actionNextTimeSplit = actionNextTimeAux?.split("+");
    mapShortcutState(
      actionNextTimeSplit,
      setActionNextTimeFirstId,
      setActionNextTimeFirstName,
      setActionNextTimeSecondId,
      setActionNextTimeSecondName,
    );

    const slowSpeedAux = listShortcuts.find(
      (x) => x?.name === "slowSpeed",
    )?.value;
    const slowSpeedSplit = slowSpeedAux?.split("+");
    mapShortcutState(
      slowSpeedSplit,
      setSlowSpeedFirstId,
      setSlowSpeedFirstName,
      setSlowSpeedSecondId,
      setSlowSpeedSecondName,
    );

    const fastSpeedAux = listShortcuts.find(
      (x) => x?.name === "fastSpeed",
    )?.value;
    const fastSpeedSplit = fastSpeedAux?.split("+");
    mapShortcutState(
      fastSpeedSplit,
      setFastSpeedFirstId,
      setFastSpeedFirstName,
      setFastSpeedSecondId,
      setFastSpeedSecondName,
    );

    const timeBackNextAux = listShortcuts.find(
      (x) => x?.name === "timeBackNext",
    )?.value;

    const timeBackNextAuxId: number =
      timeBackNextAux === "" ? 0 : parseInt(timeBackNextAux as string);
    setTimeBackNextId(timeBackNextAuxId);
    const timeBackNextAuxName = listSecondsToNextBack.find(
      (x) => x?.id === timeBackNextAuxId,
    )?.name;
    setTimeBackNextName(
      timeBackNextAuxName === undefined ? "5 segundos" : timeBackNextAuxName,
    );
  }

  function mapShortcutState(
    array: string[] | undefined,
    setOneId: (e: number) => unknown,
    setOneName: (e: string) => unknown,
    setTwoId: (e: number) => unknown,
    setTwoName: (e: string) => unknown,
  ) {
    if (array?.length === 1) {
      const name2: string = array[0];
      const getIdList = listSecondShortcut.find((x) => x?.name === name2)?.id;
      const id: number = getIdList === undefined ? 0 : (getIdList as number);
      setTwoId(id);
      setTwoName(mapArrowsShortcut(name2));

      // setando "nenhum" no primeiro drop quando atalho é apenas uma tecla
      const shortcutNenhum = listFirstShortcut[0];
      setOneId(shortcutNenhum?.id as number);
      setOneName(shortcutNenhum?.name);
    } else if (array?.length === 2) {
      const name1: string = array[0];
      const getIdList1 = listFirstShortcut.find((x) => x?.name === name1)?.id;
      const id1: number = getIdList1 === undefined ? 0 : (getIdList1 as number);
      setOneId(id1);
      setOneName(name1);

      const name2: string = array[1];
      const name22 = mapArrowsShortcut(name2);
      const getIdList2 = listSecondShortcut.find((x) => x?.name === name22)?.id;

      const id2: number = getIdList2 === undefined ? 0 : (getIdList2 as number);
      setTwoId(id2);
      setTwoName(name22);
    }
  }

  function mapArrowsShortcut(shortcut: string) {
    if (shortcut === "ArrowLeft") {
      shortcut = t("constants.arrowLeft");
    } else if (shortcut === "ArrowUp") {
      shortcut = t("constants.arrowUp");
    } else if (shortcut === "ArrowRight") {
      shortcut = t("constants.arrowRight");
    } else if (shortcut === "ArrowDown") {
      shortcut = t("constants.arrowDown");
    }
    return shortcut;
  }

  const [configurationsList, setConfigurationsList] = useState<any>([]);
  const [labelList, setLabelList] = useState<any>([]);
  const [search, setSearch] = useState<any>("");
  const [filterList, setFilterList] = useState<any>([]);
  const [passwordType, setPasswordType] = useState<typesInput>("password");
  const [itemEdit, setItemEdit] = useState<any>();
  const [editedValue, setEditedValue] = useState<any>("");
  const [filePathMark, setFilePathMark] = useState<any>("");
  const [file, setFile] = useState<any>();
  const [typeMark, setTypeMark] = useState(1);

  const applySelectedItem = (selectedItemId: number) => {
    setConfigurationsList((prevList: any[]) =>
      prevList.map((configuration: any) => ({
        ...configuration,
        selected: configuration?.id === selectedItemId,
      })),
    );
    setFilterList((prevList: any[]) =>
      prevList.map((configuration: any) => ({
        ...configuration,
        selected: configuration?.id === selectedItemId,
      })),
    );
  };

  const configKeyMap: Record<string, string> = {
    ExpireInHearingFileUrl: "systemConfiguration.items.expireInHearingFileUrl",
    MfaConfiguration: "systemConfiguration.items.mfaConfiguration",
    ServiceIntegrationAuthentication:
      "systemConfiguration.items.serviceIntegrationAuthentication",
    ServiceIntegrationImportation:
      "systemConfiguration.items.serviceIntegrationImportation",
    LoginConfiguration: "systemConfiguration.items.loginConfiguration",
    MConf: "systemConfiguration.items.mConf",
    MConfWebhook: "systemConfiguration.items.mConfWebhook",
    AccessVideoExpiration: "systemConfiguration.items.accessVideoExpiration",
    CustomerProcedureDeadline:
      "systemConfiguration.items.customerProcedureDeadline",
    DaysToGetProcedure: "systemConfiguration.items.daysToGetProcedure",
    ExternalLinkTextEmail: "systemConfiguration.items.externalLinkTextEmail",
    FacialRecognition: "systemConfiguration.items.facialRecognition",
    FilterPeriod: "systemConfiguration.items.filterPeriod",
    LogoCustomer: "systemConfiguration.items.logoCustomer",
    MicrosoftGraphAutentication:
      "systemConfiguration.items.microsoftGraphAuthentication",
    NotificationAuto: "systemConfiguration.items.notificationAuto",
    PaginationList: "systemConfiguration.items.paginationList",
    ProcedureMask: "systemConfiguration.items.procedureMask",
    RecordProvider: "systemConfiguration.items.recordProvider",
    ServiceIntegrationNotification:
      "systemConfiguration.items.serviceIntegrationNotification",
    Shortcuts: "systemConfiguration.items.shortcuts",
    StorageProvider1: "systemConfiguration.items.storageProvider",
    TranscriptionProvider: "systemConfiguration.items.transcriptionProvider",
    TranscriptionSummary: "systemConfiguration.items.transcriptionSummary",
    Watermark: "systemConfiguration.items.watermark",
    WatermarkProvider: "systemConfiguration.items.watermarkProvider",
    EndMeetingWhenNoModeratorInMinutes:
      "systemConfiguration.items.endMeetingWhenNoModerator",
    MConfDownloadVideo: "systemConfiguration.items.mConfDownloadVideo",
    AutoTranscription: "systemConfiguration.items.autoTranscription",
  };

  const getAllConfigurationsByCustomerId = async () => {
    const { data, status } = await SystemConfigurationService.getAllByCustomer(
      user?.customerId,
    );
    if (status) {
      const list = data
        ?.filter(
          (item: any) => item.visible && item.name !== "IdentityProvider",
        )
        .map((item: any) => ({
          ...item,
          value: item.value,
          description: configKeyMap[item.name]
            ? t(configKeyMap[item.name])
            : item.description,
          selected: false,
        }));

      dispatch(updateGlobalConfigurationsAction(data));
      setConfigurationsList(list);
      setFilterList(list);
    }
  };

  const getWaterMark = async () => {
    const { data, success } = await SystemConfigurationService.getWatermark(
      user?.customerId,
    );

    if (success) {
      setTypeMark(data.layout);
      setLabelList(data.label.split(";"));
      setFilePathMark(data.filepath);
      systemWaterMarkId.current = data.id;
      systemWaterMark.current = data;
    }
  };

  useEffect(() => {
    getAllConfigurationsByCustomerId();
    getWaterMark();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setSelectedListFirstShortcut(listFirstShortcut);
      setSelectedListSecondShortcut(listSecondShortcut);
      setSelectedListSecondsToNextBack(listSecondsToNextBack);
      setSelectedListPagination(listPagination);
      await onLoadList();
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (!listPagination?.length) onLoadList();
  }, [showModal]);

  function hasDuplicateLabel(
    arr: { name: string; label: string; type: string }[],
  ): boolean {
    const labels = arr.map((item) => item.label);
    return labels.some((label, index) => labels.indexOf(label) !== index);
  }
  const formatWithMask = (value: string | null) => {
    if (!value) {
      return "";
    }
    return value
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  const putConfiguration = async () => {
    let webhookPayload = mConfWebhookValue;

    if (/\\d/.test(editedValue)) {
      setFieldError(true);
      return addToast({
        type: "warning",
        title: t("common.warning"),
        description: t("systemConfiguration.toasts.invalidMask"),
      });
    }
    if (
      itemEdit.name !== "ProcedureMask" &&
      !editedValue &&
      editedValue !== 0
    ) {
      setFieldError(true);
      return addToast({
        type: "warning",
        title: t("common.warning"),
        description: t("systemConfiguration.toasts.fillRequiredFields"),
      });
    }

    const allowedTypes = new Set(["image/png", "image/svg+xml", "image/jpeg"]);
    const fileName = String(file?.name || "").toLowerCase();
    const hasAllowedExtension =
      fileName.endsWith(".png") ||
      fileName.endsWith(".svg") ||
      fileName.endsWith(".jpeg") ||
      fileName.endsWith(".jpg");
    if (file && !allowedTypes.has(file.type) && !hasAllowedExtension) {
      return addToast({
        type: "warning",
        title: t("common.warning"),
        description: t("systemConfiguration.toasts.invalidFileType"),
      });
    }

    setFieldError(false);

    if (itemEdit?.name === "MConf") {
      try {
        const obj = JSON.parse(mConfValue);
        const requiredFields = [
          "Server",
          "PwdModerator",
          "PwdAttendee",
          "SharedSecret",
        ];
        const hasEmpty = requiredFields.some(
          (field) => !obj[field] || String(obj[field]).trim() === "",
        );
        if (hasEmpty) {
          setFieldError(true);
          return addToast({
            type: "warning",
            title: t("common.warning"),
            description: t("systemConfiguration.toasts.fillRequiredFields"),
          });
        }
        if (obj.PwdModerator === obj.PwdAttendee) {
          setFieldError(true);
          return addToast({
            type: "warning",
            title: t("common.warning"),
            description: t("systemConfiguration.toasts.passwordsCannotBeEqual"),
          });
        }
      } catch {
        return addToast({
          type: "error",
          title: t("systemConfiguration.toasts.invalidJson"),
          description: t("systemConfiguration.toasts.cannotProcessValue"),
        });
      }
    }

    if (itemEdit?.name === "MConfWebhook") {
      try {
        const obj: any = JSON.parse(mConfWebhookValue || "{}");

        if (drawerButtonLabel === t("systemConfiguration.renew")) {
          if (!obj.CallbackUrl || String(obj.CallbackUrl).trim() === "") {
            setFieldError(true);
            return addToast({
              type: "warning",
              title: t("common.warning"),
              description: t("systemConfiguration.toasts.callbackUrlRequired"),
            });
          }

          obj.AuthToken = "";
          obj.HookId = "";

          webhookPayload = JSON.stringify(obj);

          setMConfWebhookValue(webhookPayload);
        } else {
          const requiredFields = ["CallbackUrl", "AuthToken", "HookId"];
          const hasEmpty = requiredFields.some(
            (field) => !obj[field] || String(obj[field]).trim() === "",
          );
          if (hasEmpty) {
            setFieldError(true);
            return addToast({
              type: "warning",
              title: t("common.warning"),
              description: t("systemConfiguration.toasts.fillRequiredFields"),
            });
          }
        }
      } catch {
        return addToast({
          type: "error",
          title: t("systemConfiguration.toasts.invalidJson"),
          description: t("systemConfiguration.toasts.cannotProcessValue"),
        });
      }
    }

    dispatch(showLoading());
    setLoading(true);

    if (itemEdit?.name === "TranscriptionProvider") {
      await SystemConfigurationService.patch(editedValue, itemEdit.id);
      await SystemConfigurationService.patch(withIndexing ? "1" : "0", "141");
    }

    if (itemEdit?.name === "WatermarkProvider") {
      await SystemConfigurationService.patch(editedValue, itemEdit.id);
    }

    if (
      itemEdit?.name !== "ServiceIntegrationAuthentication" &&
      itemEdit?.name !== "ServiceIntegrationImportation" &&
      itemEdit?.name !== "ServiceIntegrationNotification" &&
      itemEdit?.name !== "MicrosoftGraphAutentication" &&
      itemEdit?.name !== "WatermarkProvider" &&
      itemEdit?.name !== "TranscriptionProvider"
    ) {
      await SystemConfigurationService.patch(
        itemEdit?.name === "Shortcuts"
          ? serializeShortcuts()
          : itemEdit?.name === "LogoCustomer"
            ? customerLogo
            : itemEdit?.name === "ProcedureMask"
              ? formatWithMask(editedValue)
              : itemEdit?.name === "MConfWebhook"
                ? webhookPayload
                : itemEdit?.name === "MConf"
                  ? mConfValue
                  : editedValue,
        itemEdit?.id,
      );
    }

    if (itemEdit?.name === "MicrosoftGraphAutentication") {
      await SystemConfigurationService.patch(
        serviceMicrosoftGraphAutenticationValue,
        itemEdit?.id,
      );
    }

    if (itemEdit?.name === "ServiceIntegrationAuthentication") {
      await SystemConfigurationService.patch(
        serviceIntegrationAuthenticationValue,
        itemEdit?.id,
      );
    }
    if (itemEdit?.name === "ServiceIntegrationImportation") {
      const isDuplicate = hasDuplicateLabel(
        JSON.parse(serviceIntegrationImportationValue).parametros,
      );
      if (isDuplicate) {
        return addToast({
          type: "error",
          title: t("common.warning"),
          description: t("systemConfiguration.toasts.duplicateLabel"),
        });
      }

      await SystemConfigurationService.patch(
        serviceIntegrationImportationValue,
        itemEdit?.id,
      );
    }
    if (itemEdit?.name === "ServiceIntegrationNotification") {
      const isDuplicate = hasDuplicateLabel(
        JSON.parse(serviceIntegrationNotificationValue).parametros,
      );
      if (isDuplicate) {
        return addToast({
          type: "error",
          title: t("common.warning"),
          description: t("systemConfiguration.toasts.duplicateLabel"),
        });
      }
      await SystemConfigurationService.patch(
        serviceIntegrationNotificationValue,
        itemEdit?.id,
      );
    }

    if (itemEdit?.name === "Watermark") {
      const labelListString = labelList.join(";");

      if (file) {
        Resizer.imageFileResizer(
          file,
          80,
          102,
          "PNG",
          100,
          0,
          async (fileResized: any) => {
            await SystemConfigurationService.uploadFile(
              fileResized,
              containerName,
              file?.name,
            );
          },
          "file",
          50,
          102,
        );
      }

      if (file) {
        setFilePathMark(file.name);
      }

      if (systemWaterMark !== null && systemWaterMark.current) {
        await SystemConfigurationService.updateWatermark(
          systemWaterMarkId.current,
          labelListString || null,
          typeMark,
          file ? file.name : systemWaterMark.current.filepath,
          systemWaterMark.current.provider,
        );
      }
    }

    await getAllConfigurationsByCustomerId();
    setSelectedListFirstShortcut(listFirstShortcut);
    setSelectedListSecondShortcut(listSecondShortcut);
    setSelectedListSecondsToNextBack(listSecondsToNextBack);
    setSelectedListPagination(listPagination);
    await onLoadList();
    setShowModal(false);
    setPasswordType("password");
    dispatch(hideLoading());
    setLoading(false);

    addToast({
      type: "success",
      title: t("systemConfiguration.toasts.configUpdated"),
      description: t("systemConfiguration.toasts.configUpdatedDescription"),
    });
  };

  const erroAplay = async () => {
    if (errorSIAuthent) {
      addToast({
        type: "error",
        title: t("systemConfiguration.toasts.invalidJson"),
        description: t("systemConfiguration.toasts.checkParameters"),
      });
    }
  };

  const selectType = (type: number) => {
    setTypeMark(type);
  };

  const [customerLogo, setCustomerLogo] = useState(null);
  const [errorSIAuthent, setErrorSIAuthent] = useState<any>();

  //========itemEdit.name === "MicrosoftGraphAutentication"
  const [
    serviceMicrosoftGraphAutentication,
    setServiceMicrosoftGraphAutentication,
    ,
  ] = useState<any>();
  const [
    serviceMicrosoftGraphAutenticationValue,
    setServiceMicrosoftGraphAutenticationValue,
  ] = useState(serviceMicrosoftGraphAutentication || "");

  //========itemEdit.name === "ServiceIntegrationAuthentication"
  const [
    serviceIntegrationAuthentication,
    setServiceIntegrationAuthentication,
  ] = useState<any>();
  const [
    serviceIntegrationAuthenticationValue,
    setServiceIntegrationAuthenticationdValue,
  ] = useState(serviceIntegrationAuthentication || "");

  //========itemEdit.name === "ServiceIntegrationImportation"
  const [serviceIntegrationImportation, setServiceIntegrationImportation] =
    useState<any>();
  const [
    serviceIntegrationImportationValue,
    setServiceIntegrationImportationValue,
  ] = useState(serviceIntegrationImportation || "");

  //========itemEdit.name === "ServiceIntegrationNotification"
  const [serviceIntegrationNotification, setServiceIntegrationNotification] =
    useState<any>();
  const [
    serviceIntegrationNotificationValue,
    setServiceIntegrationNotificationValue,
  ] = useState(serviceIntegrationNotification || "");

  const closeAll = () => {
    setShowModal(false);
    setFieldError(false);
    setCustomerLogo(null);
    setEditedValue("0");
    dispatch(hideLoading());
    setPasswordType("password");
    setShortCutsErrorPlayStop(false);
    setShortCutsErrorActionBackTime(false);
    setShortCutsErrorActionNextTime(false);
    setShortCutsErrorSlowSpeed(false);
    setShortCutsErrorFastSpeed(false);
    setErrorSIAuthent(null);
    setServiceIntegrationNotificationValue(serviceIntegrationNotification);
    setServiceIntegrationImportationValue(serviceIntegrationImportation);
    setMConfValue(mConf);
    setMConfWebhookValue(mConfWebhook);
    setDrawerButtonLabel(t("common.apply"));
    setShowRenewModal(false);
  };

  const onPressEdit = (item: any) => {
    applySelectedItem(item.id);

    if (
      item.name === "Watermark" ||
      item.name === "FacialRecognition" ||
      item.name === "NotificationAuto" ||
      item.name === "TranscriptionSummary"
    ) {
      setSelectedYesOrNoName(
        item.value === "1" ? t("common.yes") : t("common.no"),
      );
    }

    if (item.name === "LogoCustomer") {
      setSelectedYesOrNoName(item.value ? t("common.yes") : t("common.no"));
      setCustomerLogo(item.value);
    }

    if (item.name === "MicrosoftGraphAutentication") {
      setServiceMicrosoftGraphAutentication(item.value);
    }
    if (item.name === "ServiceIntegrationAuthentication") {
      setServiceIntegrationAuthentication(item.value);
    }
    if (item.name === "ServiceIntegrationImportation") {
      setServiceIntegrationImportation(item.value);
    }
    if (item.name === "ServiceIntegrationNotification") {
      setServiceIntegrationNotification(item.value);
    }
    if (item.name === "RecordProvider") {
      const nameRecordProvider = listRecordProvider.find(
        (provider) => provider.id === parseInt(item.value),
      )?.name;
      if (nameRecordProvider) {
        setSelectedRecordProvider(nameRecordProvider);
      }
    }

    if (item.name === "MConf") {
      setMConf(item.value);
      setMConfValue(item.value);
    }
    if (item.name === "MConfWebhook") {
      setMConfWebhook(item.value);
      setMConfWebhookValue(item.value);
      const registered = isWebhookRegistered(item.value);
      setDrawerButtonLabel(
        registered
          ? t("systemConfiguration.renew")
          : t("systemConfiguration.register"),
      );
    }
    if (item.name === "AccessVideoExpiration") {
      setSelectedAccessVideoExpirationName(item.value);
    }
    if (item.name === "ExpireInHearingFileUrl") {
      setSelectedExpireInHearingFileUrlName(item.value);
    }

    setItemEdit(item);
    setEditedValue(item.value);
    setShowModal(true);
  };

  const onChangeFiles = (file: any) => {
    if (!file) {
      addToast({
        type: "warning",
        title: t("common.warning"),
        description: t("systemConfiguration.toasts.invalidFileType"),
      });
      return;
    }

    Resizer.imageFileResizer(
      file,
      20,
      100,
      "PNG",
      100,
      0,
      async (fileResized: any) => {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          setCustomerLogo(e.target.result);
        };

        reader.readAsDataURL(fileResized);
      },
      "file",
      20,
      100,
    );
  };

  const getNameIfIdMatches = (array: any[], editedValue: string) => {
    const foundItem = array.find((item) => item?.id === Number(editedValue));
    return foundItem ? foundItem.name : null;
  };

  const whatIsEdit = (name: string) => {
    switch (name) {
      case "LoginConfiguration":
        return (
          <LoginConfigurationCustom
            editedValue={editedValue}
            setEditedValue={setEditedValue}
          />
        );
      case "TranscriptionSummary":
        return (
          <DropdownGlobal
            labelName={t("systemConfiguration.items.transcriptionSummary")}
            options={listYesOrNoAux}
            error={fieldError}
            setSelected={setEditedValue}
            required={false}
            editDropdown={selectedYesOrNoName}
            defaultValue={selectedYesOrNoName}
          />
        );
      case "RecordProvider":
        return (
          <DropdownGlobal
            labelName={t("systemConfiguration.items.recordProvider")}
            options={listRecordProvider}
            error={fieldError}
            setSelected={setEditedValue}
            required={false}
            editDropdown={selectedRecordProvider}
            defaultValue={selectedRecordProvider}
          />
        );
      case "TranscriptionProvider":
        return (
          <TranscriptionProvider
            editConfig={editConfig}
            editedValue={editedValue}
            fieldError={fieldError}
            getNameIfIdMatches={getNameIfIdMatches}
            setEditedValue={setEditedValue}
            withIndexing={withIndexing}
            setWithIndexing={setWithIndexing}
          />
        );
      case "WatermarkProvider":
        return (
          <WatermarkProvider
            listWaterMarkProvider={listWaterMarkProvider}
            editedValue={editedValue}
            fieldError={fieldError}
            getNameIfIdMatches={getNameIfIdMatches}
            setEditedValue={setEditedValue}
          />
        );
      case "StorageProvider1":
        return (
          <StorageProviderCustom
            description={itemEdit.description}
            selectedStorageProviderList={listProviderAux}
            setEditedValue={setEditedValue}
            getNameIfIdMatches={getNameIfIdMatches}
            editedValue={editedValue}
            fieldError={fieldError}
            passwordType={passwordType}
            setPasswordType={setPasswordType}
          />
        );
      case "LogoCustomer":
        return (
          <LogoCustom
            customerLogo={customerLogo}
            editedValue={editedValue}
            onChangeFiles={onChangeFiles}
            setCustomerLogo={setCustomerLogo}
            setEditedValue={setEditedValue}
            fieldError={fieldError}
            selectedYesOrNoName={selectedYesOrNoName}
          />
        );
      case "Watermark":
        return (
          <WatermarkCustom
            editedValue={editedValue}
            fieldError={fieldError}
            selectType={selectType}
            selectedYesOrNoName={selectedYesOrNoName}
            setEditedValue={setEditedValue}
            setFile={setFile}
            typeMark={typeMark}
            labelList={labelList}
            setLabelList={setLabelList}
            filePathMark={filePathMark}
            systemWaterMark={systemWaterMark}
            getNameIfIdMatches={getNameIfIdMatches}
          />
        );
      case "MicrosoftGraphAutentication":
        return (
          <ServiceIntegrationAuthentication
            serviceIntegrationAuthentication={
              serviceMicrosoftGraphAutentication
            }
            textFieldValue={serviceMicrosoftGraphAutenticationValue}
            setTextFieldValue={setServiceMicrosoftGraphAutenticationValue}
            errorSIAuthent={errorSIAuthent}
            setErrorSIAuthent={setErrorSIAuthent}
          />
        );
      case "ServiceIntegrationAuthentication":
        return (
          <ServiceIntegrationAuthentication
            serviceIntegrationAuthentication={serviceIntegrationAuthentication}
            textFieldValue={serviceIntegrationAuthenticationValue}
            setTextFieldValue={setServiceIntegrationAuthenticationdValue}
            errorSIAuthent={errorSIAuthent}
            setErrorSIAuthent={setErrorSIAuthent}
          />
        );
      case "ServiceIntegrationImportation":
        return (
          <ServiceIntegrationImportation
            serviceIntegrationImportation={serviceIntegrationImportation}
            textFieldValue={serviceIntegrationImportationValue}
            setTextFieldValue={setServiceIntegrationImportationValue}
            errorSIAuthent={errorSIAuthent}
            setErrorSIAuthent={setErrorSIAuthent}
          />
        );
      case "ServiceIntegrationNotification":
        return (
          <ServiceIntegrationNotification
            serviceIntegrationNotification={serviceIntegrationNotification}
            textFieldValue={serviceIntegrationNotificationValue}
            setTextFieldValue={setServiceIntegrationNotificationValue}
            errorSIAuthent={errorSIAuthent}
            setErrorSIAuthent={setErrorSIAuthent}
          />
        );
      case "MConf":
        return (
          <MConfConfiguration
            mConf={mConf}
            textFieldValue={mConfValue}
            setTextFieldValue={setMConfValue}
            errorSIAuthent={errorSIAuthent}
            setErrorSIAuthent={setErrorSIAuthent}
          />
        );
      case "MConfWebhook":
        return (
          <MConfWebhookConfiguration
            mConfWebhook={mConfWebhook}
            textFieldValue={mConfWebhookValue}
            setTextFieldValue={setMConfWebhookValue}
            errorSIAuthent={errorSIAuthent}
            setErrorSIAuthent={setErrorSIAuthent}
          />
        );
      case "NotificationAuto":
        return (
          <DropdownGlobal
            labelName={t("systemConfiguration.items.notificationAuto")}
            options={listYesOrNoAux}
            error={fieldError}
            setSelected={setEditedValue}
            required={false}
            editDropdown={selectedYesOrNoName}
            defaultValue={selectedYesOrNoName}
          />
        );
      case "DaysToGetProcedure":
        return (
          <DropdownGlobal
            labelName={t("systemConfiguration.items.daysToGetProcedure")}
            options={listDaysAux}
            error={fieldError}
            setSelected={setEditedValue}
            required={false}
            editDropdown={selectedDaysToGetProcedureName}
            defaultValue={selectedDaysToGetProcedureName}
          />
        );
      case "FilterPeriod":
        return (
          <DropdownGlobal
            labelName={t("audiences.filterPeriod")}
            options={listFilterPeriodDays}
            error={fieldError}
            setSelected={setEditedValue}
            required={false}
            editDropdown={selectedFilterPeriodName}
            defaultValue={selectedFilterPeriodName}
          />
        );
      case "FacialRecognition":
        return (
          <DropdownGlobal
            labelName={t("systemConfiguration.items.facialRecognition")}
            options={listYesOrNoAux}
            error={fieldError}
            setSelected={setEditedValue}
            required={false}
            editDropdown={selectedYesOrNoName}
            defaultValue={selectedYesOrNoName}
          />
        );
      case "PaginationList":
        return (
          <DropdownGlobal
            labelName={t("systemConfiguration.items.paginationList")}
            options={selectedListPagination}
            error={fieldError}
            setSelected={(e: any) => setEditedValue(e)}
            required={false}
            editDropdown={valuePaginationName}
            defaultValue={valuePaginationName}
          />
        );
      case "Shortcuts":
        return (
          <ShortCuts
            listSecondsToNextBack={selectedListSecondsToNextBack}
            listFirstShortcut={selectedListFirstShortcut}
            listSecondShortcut={selectedListSecondShortcut}
            setTimeBackNextId={setTimeBackNextId}
            setPlayStopFirstId={setPlayStopFirstId}
            setPlayStopSecondId={setPlayStopSecondId}
            setActionBackTimeFirstId={setActionBackTimeFirstId}
            setActionBackTimeSecondId={setActionBackTimeSecondId}
            setActionNextTimeFirstId={setActionNextTimeFirstId}
            setActionNextTimeSecondId={setActionNextTimeSecondId}
            setFastSpeedFirstId={setFastSpeedFirstId}
            setFastSpeedSecondId={setFastSpeedSecondId}
            setSlowSpeedFirstId={setSlowSpeedFirstId}
            setSlowSpeedSecondId={setSlowSpeedSecondId}
            valueTimeBackNextName={valueTimeBackNextName}
            valuePlayStopFirstName={valuePlayStopFirstName}
            valuePlayStopSecondName={valuePlayStopSecondName}
            valueActionBackTimeFirstName={valueActionBackTimeFirstName}
            valueActionBackTimeSecondName={valueActionBackTimeSecondName}
            valueActionNextTimeFirstName={valueActionNextTimeFirstName}
            valueActionNextTimeSecondName={valueActionNextTimeSecondName}
            valueFastSpeedFirstName={valueFastSpeedFirstName}
            valueFastSpeedSecondName={valueFastSpeedSecondName}
            valueSlowSpeedFirstName={valueSlowSpeedFirstName}
            valueSlowSpeedSecondName={valueSlowSpeedSecondName}
            shortCutsErrorplayStop={shortCutsErrorplayStop}
            shortCutsErrorActionBackTime={shortCutsErrorActionBackTime}
            shortCutsErrorActionNextTime={shortCutsErrorActionNextTime}
            shortCutsErrorSlowSpeed={shortCutsErrorSlowSpeed}
            shortCutsErrorFastSpeed={shortCutsErrorFastSpeed}
          />
        );
      case "CustomerProcedureDeadline":
        return (
          <CustomerProcedureDeadline
            editedValue={editedValue}
            setEditedValue={setEditedValue}
            fieldError={fieldError}
            label={t("systemConfiguration.customerProcedureDeadline.label")}
          />
        );
      case "ProcedureMask":
        return (
          <ProcedureMask
            setEditedValue={setEditedValue}
            editedValue={editedValue}
          />
        );
      case "AccessVideoExpiration":
        return (
          <AccessVideoExpiration
            editedValue={editedValue}
            setEditedValue={setEditedValue}
            fieldError={fieldError}
            selectedAccessVideoExpirationName={
              selectedAccessVideoExpirationName
            }
          />
        );
      case "ExpireInHearingFileUrl":
        return (
          <ExpireInHearingFileUrl
            editedValue={editedValue}
            setEditedValue={setEditedValue}
            fieldError={fieldError}
            selectedExpireInHearingFileUrlName={
              selectedExpireInHearingFileUrlName
            }
          />
        );
      case "ExternalLinkTextEmail":
        return (
          <ExternalLinkTextEmail
            editedValue={editedValue}
            setEditedValue={setEditedValue}
            fieldError={fieldError}
          />
        );
      case "EmailTemplate":
        return (
          <EmailTemplate
            editedValue={editedValue}
            setEditedValue={setEditedValue}
            fieldError={fieldError}
          />
        );
      case "MfaConfiguration":
        return (
          <MFAConfiguration
            editedValue={editedValue}
            setEditedValue={setEditedValue}
            fieldError={fieldError}
          />
        );
      default:
        return <div />;
    }
  };

  useEffect(() => {
    if (search) {
      setFilterList(
        configurationsList?.filter((x: any) =>
          x.description.toLowerCase().includes(search.toLowerCase()),
        ),
      );
    } else {
      setFilterList(configurationsList);
    }
  }, [configurationsList, search]);

  function isWebhookRegistered(value: string | null | undefined): boolean {
    try {
      const obj = JSON.parse(value || "{}");
      return (
        obj.AuthToken &&
        String(obj.AuthToken).trim() !== "" &&
        obj.HookId &&
        String(obj.HookId).trim() !== ""
      );
    } catch {
      return false;
    }
  }

  const handleDrawerApply = () => {
    if (drawerButtonLabel === t("systemConfiguration.renew")) {
      setShowRenewModal(true);
      return;
    }
    if (errorSIAuthent) {
      erroAplay();
    } else {
      putConfiguration();
    }
  };

  return (
    <Container>
      <AdminArea
        title={t("systemConfiguration.globalConfigurations")}
        InputSearchLabel={t("common.searchBy")}
        InputSearchOnChange={(text: any) => setSearch(text)}
        searchText={search}
        list={filterList}
        onClick={(item: any) => onPressEdit(item)}
        setItemReturnClick={() => {}}
        setOpenModal={setShowModal}
        permissionName={FORMS_ADMIN.SYSTEM_CONFIGURATION}
        onChangeSituation={() => {}}
        showStatus={false}
        displayAtivoFilter={false}
        description={true}
        loading={loading}
      />
      <Drawer
        open={showModal}
        onClose={() => closeAll()}
        paddingLeft={1}
        paddingRight={1}
        title={
          itemEdit && itemEdit.name === "Shortcuts"
            ? itemEdit.description
            : t("systemConfiguration.editConfiguration")
        }
        onApply={handleDrawerApply}
        applyLabel={drawerButtonLabel}
      >
        <div
          style={{
            overflowY: "auto",
            overflowX: "hidden",
            height: "71vh",
            width: "430px",
            padding: "0 20px",
          }}
        >
          {itemEdit && itemEdit.name ? whatIsEdit(itemEdit.name) : <div />}
        </div>
      </Drawer>
      <ModalDefault
        openModal={showRenewModal}
        setOpenModal={() => setShowRenewModal(false)}
        title={t("systemConfiguration.deleteWebhook")}
        bodyMessageTitle={t("systemConfiguration.confirmDeleteWebhook")}
        bodyMessageSubTitle={t("audiences.status.updateError")}
        textConfirm={t("common.delete").toUpperCase()}
        onClickConfirm={() => {
          setShowRenewModal(false);
          putConfiguration();
        }}
        textCancel={t("common.cancel").toUpperCase()}
        onClickCancel={() => setShowRenewModal(false)}
      />
      <LoadSpinner loading={loading} zindex={1300} />
    </Container>
  );
}
